import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "@/hooks/use-toast";
import { ProjectHeader } from "@/components/ProjectHeader";
import { RFIEmailEditor } from "@/components/rfi/RFIEmailEditor";

export default function RFIEmail() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");

  const goToDatabook = useCallback(() => {
    if (!projectId) {
      toast({
        title: "No active project selected",
        description: "Please open the tracker from a project.",
        variant: "destructive",
      });
      return;
    }
    navigate(`/databook-builder?projectId=${encodeURIComponent(projectId)}`);
  }, [navigate, projectId]);

  return (
    <div className="min-h-screen bg-background">
      <ProjectHeader backTo="/rfi-tracker" />
      <main className="container mx-auto px-8 py-8">
        {projectId ? (
          <RFIEmailEditor
            projectId={projectId}
            onContinue={goToDatabook}
            onSkip={() => navigate(-1)}
          />
        ) : null}
      </main>
    </div>
  );
}
